import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import HistoryIcon from '@mui/icons-material/History';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const BannerInfoTransaccionesIa = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA',
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
                    <ReceiptLongIcon sx={{ color: '#696CFF', fontSize: 32 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                        ¿Qué son las Transacciones de Créditos?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                        Desde este módulo puedes visualizar el historial completo de movimientos, consumos y recargas de créditos para cada suscripción. Te permite auditar de forma precisa cuándo y por qué cambiaron los balances de los clientes.
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <SyncAltIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Flujo de Créditos</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Supervisa el balance anterior y posterior a cada movimiento, detallando la cantidad exacta de créditos descontados o agregados.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <HistoryIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Trazabilidad Histórica</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Consulta la fecha y hora exacta de cada operación, así como referencias externas que originaron la transacción.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <InfoOutlinedIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Detalle de Consumo</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Identifica el tipo de transacción (uso de IA, recargas manuales, devoluciones) mediante las descripciones detalladas.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
